import '../../assets/index28.css';var G = Object.defineProperty, H = Object.defineProperties;
var J = Object.getOwnPropertyDescriptors;
var _ = Object.getOwnPropertySymbols;
var D = Object.prototype.hasOwnProperty, A = Object.prototype.propertyIsEnumerable;
var N = (n, s, r) => s in n ? G(n, s, { enumerable: !0, configurable: !0, writable: !0, value: r }) : n[s] = r, F = (n, s) => {
  for (var r in s || (s = {}))
    D.call(s, r) && N(n, r, s[r]);
  if (_)
    for (var r of _(s))
      A.call(s, r) && N(n, r, s[r]);
  return n;
}, L = (n, s) => H(n, J(s));
var R = (n, s) => {
  var r = {};
  for (var l in n)
    D.call(n, l) && s.indexOf(l) < 0 && (r[l] = n[l]);
  if (n != null && _)
    for (var l of _(n))
      s.indexOf(l) < 0 && A.call(n, l) && (r[l] = n[l]);
  return r;
};
import { jsxs as S, jsx as i } from "react/jsx-runtime";
import { forwardRef as K, useState as W, useMemo as v } from "react";
import { SearchBar as Q } from "../SearchBar/index.js";
import { Stack as X } from "../Stack/index.js";
import { Text as Y } from "../Text/index.js";
import { AngleDownFarFAIcon as Z, CircleExclamationFarFAIcon as ee } from "../Icons/index.js";
import { ErrorMessage as oe } from "../../molecules/ErrorMessage/index.js";
import { g as ne, a as te, u as le, C as d } from "../../Combobox-CmRRrGfX.js";
import { u as se } from "../../use-uncontrolled-BT_j5D2R.js";
import { I as re } from "../../InputBase-Cabx1d9o.js";
const ie = "InlineSelect-module__inlineSelectRoot___68jD5", ae = "InlineSelect-module__searchContainer___IRF7H", ce = "InlineSelect-module__inlineSelect___NwoUe", pe = "InlineSelect-module__options___5USp9", ue = "InlineSelect-module__option___KyvwU", de = "InlineSelect-module__emptyState___eOvWq", fe = "InlineSelect-module__supportingText___46Oaw", he = "InlineSelect-module__description___0Jz-7", c = {
  inlineSelectRoot: ie,
  searchContainer: ae,
  inlineSelect: ce,
  options: pe,
  option: ue,
  emptyState: de,
  supportingText: fe,
  description: he
}, me = K(
  (Se, P) => {
    var O = Se, {
      allowDeselect: n = !1,
      defaultValue: s,
      disabled: r,
      data: l,
      placeholder: T,
      onChange: k,
      value: M,
      className: j,
      width: z,
      variant: f = "default",
      searchPlaceholder: U = "Search...",
      children: B,
      error: b,
      description: y
    } = O, E = R(O, [
      "allowDeselect",
      "defaultValue",
      "disabled",
      "data",
      "placeholder",
      "onChange",
      "value",
      "className",
      "width",
      "variant",
      "searchPlaceholder",
      "children",
      "error",
      "description"
    ]);
    const [p, I] = W(""), u = v(() => ne(l), [l]), V = v(() => f !== "searchable" || !p ? u : u.filter(
      (t) => {
        var e;
        return (e = t == null ? void 0 : t.label) == null ? void 0 : e.toLowerCase().includes(p.toLowerCase());
      }
    ), [u, p, f]), w = v(() => te(u), [u]), a = le({
      onDropdownClose: () => {
        a.resetSelectedOption(), f === "searchable" && I("");
      },
      onDropdownOpen: (t) => {
        t === "keyboard" ? a.selectActiveOption() : a.updateSelectedOptionIndex("active");
      }
    }), $ = () => {
      if (!l || l.length === 0) return "";
      if (!Array.isArray(l))
        return u.length > 0 ? u[0].value : "";
      for (const t of l) {
        if (typeof t == "string")
          return t;
        if ("group" in t) {
          if (t.items.length > 0) {
            const e = t.items[0];
            return typeof e == "string" ? e : e.value;
          }
        } else
          return t.value;
      }
      return "";
    }, [h, C] = se({
      value: M,
      defaultValue: s || $(),
      onChange: k
    }), g = typeof h == "string" ? w[h] : void 0, q = (t) => {
      const e = w[t];
      if (n && t === h) {
        C("", e), a.updateSelectedOptionIndex("active"), a.closeDropdown();
        return;
      }
      C(t, e), a.updateSelectedOptionIndex("active"), a.closeDropdown();
    }, x = (() => {
      if (!Array.isArray(l))
        return V.map((e, m) => /* @__PURE__ */ i(
          d.Option,
          {
            active: e.value === h,
            value: e.value,
            onMouseOver: () => a.selectOption(m),
            className: c.option,
            disabled: e.disabled,
            children: e.label
          },
          e.value
        ));
      let t = 0;
      return l.map((e) => {
        if (typeof e == "string" || !("group" in e)) {
          const o = typeof e == "string" ? { label: e, value: e } : e;
          return f !== "searchable" || !p || o.label.toLowerCase().includes(p.toLowerCase()) ? /* @__PURE__ */ i(
            d.Option,
            {
              active: o.value === h,
              value: o.value,
              onMouseOver: () => a.selectOption(t++),
              className: c.option,
              disabled: o.disabled,
              children: o.label
            },
            o.value
          ) : null;
        }
        const m = e.items.filter(
          (o) => f !== "searchable" || !p || (typeof o == "string" ? o : o.label).toLowerCase().includes(p.toLowerCase())
        );
        return m.length === 0 ? null : /* @__PURE__ */ i(d.Group, { label: e.group, children: m.map((o) => /* @__PURE__ */ i(
          d.Option,
          {
            active: (typeof o == "string" ? o : o.value) === h,
            value: typeof o == "string" ? o : o.value,
            onMouseOver: () => a.selectOption(t++),
            className: c.option,
            disabled: typeof o == "string" ? !1 : o.disabled,
            children: typeof o == "string" ? o : o.label
          },
          typeof o == "string" ? o : o.value
        )) }, e.group);
      }).filter(Boolean);
    })();
    return /* @__PURE__ */ S("div", { className: c.inlineSelectRoot, children: [
      /* @__PURE__ */ S(
        d,
        {
          store: a,
          onOptionSubmit: q,
          withinPortal: !1,
          disabled: r,
          position: "bottom-start",
          offset: 0,
          children: [
            /* @__PURE__ */ i(d.Target, { children: /* @__PURE__ */ i(
              re,
              L(F({
                disabled: r,
                component: "button",
                type: "button",
                onClick: () => a.toggleDropdown(),
                pointer: !0,
                rightSection: /* @__PURE__ */ i(Z, { size: 12, color: "var(--plum-gray-8)" }),
                rightSectionPointerEvents: "none",
                classNames: {
                  input: `${c.inlineSelect} ${j || ""}`
                },
                style: { width: z },
                ref: P
              }, E), {
                children: (g == null ? void 0 : g.label) || (u.length > 0 ? u[0].label : T)
              })
            ) }),
            /* @__PURE__ */ S(d.Dropdown, { children: [
              f === "searchable" && /* @__PURE__ */ i("div", { className: c.searchContainer, children: /* @__PURE__ */ i(
                Q,
                {
                  "data-plum-id": "inline-select-search",
                  placeholder: U,
                  value: p,
                  onChange: I
                }
              ) }),
              /* @__PURE__ */ i(d.Options, { className: c.options, children: x.length > 0 ? x : f === "searchable" && p ? /* @__PURE__ */ S(X, { className: c.emptyState, children: [
                /* @__PURE__ */ i(ee, { size: 24 }),
                /* @__PURE__ */ i(Y, { size: "md", prominent: !0, c: "gray.7", children: "No results found" })
              ] }) : null }),
              B
            ] })
          ]
        }
      ),
      (y || b) && /* @__PURE__ */ i("div", { className: c.supportingText, children: b ? /* @__PURE__ */ i(oe, { error: b }) : /* @__PURE__ */ i("div", { className: c.description, children: y }) })
    ] });
  }
), _e = Object.assign(me, {
  Footer: d.Footer
});
_e.displayName = "InlineSelect";
export {
  _e as InlineSelect
};
